import { purple } from "@mui/material/colors";

const StatusChip = ({color = "green", children}) => {
    let colors = {
        green: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#ECF6DC] text-[#16432B]`,
        red: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#E4CCD7] text-[#5E203C]`,
        blue: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[#E7FDFF] text-[#204C55]`,
        purple: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-[rgb(235, 231, 255)] text-[rgb(64, 26, 129)]`,
        yellow: `px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium !bg-yellow-100 text-yellow-600`
    }
    return(
        <div
            className={colors[color]}
        >
            {children}
        </div>
    )
}

export default StatusChip;